import React from "react";
import { StoryPage } from "../../icons/icons";
import { Transition } from "../../components/common";
import { Link } from "react-router-dom";

const AnalyticsUpgrade = () => {
  return (
    <Transition transition={500} withbutton>
      <div className="stories__page page withbutton">
        <div className="page__title">Get full dashboard analytics</div>
        <div className="page__subtitle">
          Upgrade your plan to pro to use dashboard analytic
        </div>
        <div className="page__subtitle mobile__sub">
          Upgrade your plan to pro to use dashboard analytic
        </div>
        <div className="page__image">
          <StoryPage />
        </div>
        <Link to="plans">
          <div className="page__button">
            <div className="accent__button">Upgrade plan</div>
          </div>
        </Link>
      </div>
    </Transition>
  );
};

export default AnalyticsUpgrade;
